import extend from "../../services/extend";
/**
 * @ngdoc directive
 * @name ng.directive:vToggle
 * @param vue
 */

export default (vue) => extend(vue, (vue) => {
    vue.el.addEventListener (('ontouchstart' in document.documentElement ? "touchstart" : "click"), (event) => {
        event.preventDefault();
        event.stopPropagation();
        setTimeout(() => {
            vue.set(vue.exp, !vue.get(vue.exp));
        }, 300 );
    }, { passive: true });
});